// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,import_extension=none"
// @generated from file v1/image/image_service.proto (package api.v1.image, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_v1_common_common_types } from "../common/common_types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/image/image_service.proto.
 */
export const file_v1_image_image_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_protobuf_empty, file_google_protobuf_timestamp, file_v1_common_common_types]);

/**
 * @generated from message api.v1.image.Image
 */
export type Image = Message<"api.v1.image.Image"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * @generated from field: optional string original_filename = 3;
   */
  originalFilename?: string;

  /**
   * @generated from field: string mime_type = 4;
   */
  mimeType: string;

  /**
   * @generated from field: int64 size_bytes = 5;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: optional int32 width = 6;
   */
  width?: number;

  /**
   * @generated from field: optional int32 height = 7;
   */
  height?: number;

  /**
   * @generated from field: string url = 8;
   */
  url: string;

  /**
   * @generated from field: optional string storage_provider = 9;
   */
  storageProvider?: string;

  /**
   * @generated from field: string storage_path = 10;
   */
  storagePath: string;

  /**
   * @generated from field: string content_hash = 11;
   */
  contentHash: string;

  /**
   * @generated from field: optional string alt_text = 12;
   */
  altText?: string;

  /**
   * @generated from field: optional string caption = 13;
   */
  caption?: string;

  /**
   * @generated from field: optional bool is_public = 14;
   */
  isPublic?: boolean;

  /**
   * @generated from field: optional string uploaded_by = 15;
   */
  uploadedBy?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 16;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 17;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 18;
   */
  deletedAt?: Timestamp;
};

/**
 * Describes the message api.v1.image.Image.
 * Use `create(ImageSchema)` to create a new message.
 */
export const ImageSchema: GenMessage<Image> = /*@__PURE__*/
  messageDesc(file_v1_image_image_service, 0);

/**
 * EntityImage represents an image association with an entity
 *
 * @generated from message api.v1.image.EntityImage
 */
export type EntityImage = Message<"api.v1.image.EntityImage"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;

  /**
   * @generated from field: int64 entity_id = 3;
   */
  entityId: bigint;

  /**
   * @generated from field: string image_id = 4;
   */
  imageId: string;

  /**
   * @generated from field: int32 position = 5;
   */
  position: number;

  /**
   * @generated from field: string usage = 6;
   */
  usage: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message api.v1.image.EntityImage.
 * Use `create(EntityImageSchema)` to create a new message.
 */
export const EntityImageSchema: GenMessage<EntityImage> = /*@__PURE__*/
  messageDesc(file_v1_image_image_service, 1);

/**
 * GetPresignedUploadUrlRequest represents a request to get a presigned upload URL
 *
 * @generated from message api.v1.image.GetPresignedUploadUrlRequest
 */
export type GetPresignedUploadUrlRequest = Message<"api.v1.image.GetPresignedUploadUrlRequest"> & {
  /**
   * @generated from field: api.v1.image.EntityType entity_type = 1;
   */
  entityType: EntityType;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: string image_name = 3;
   */
  imageName: string;
};

/**
 * Describes the message api.v1.image.GetPresignedUploadUrlRequest.
 * Use `create(GetPresignedUploadUrlRequestSchema)` to create a new message.
 */
export const GetPresignedUploadUrlRequestSchema: GenMessage<GetPresignedUploadUrlRequest> = /*@__PURE__*/
  messageDesc(file_v1_image_image_service, 2);

/**
 * GetPresignedUploadUrlResponse represents a response containing a presigned upload URL
 *
 * @generated from message api.v1.image.GetPresignedUploadUrlResponse
 */
export type GetPresignedUploadUrlResponse = Message<"api.v1.image.GetPresignedUploadUrlResponse"> & {
  /**
   * @generated from field: string presigned_url = 1;
   */
  presignedUrl: string;
};

/**
 * Describes the message api.v1.image.GetPresignedUploadUrlResponse.
 * Use `create(GetPresignedUploadUrlResponseSchema)` to create a new message.
 */
export const GetPresignedUploadUrlResponseSchema: GenMessage<GetPresignedUploadUrlResponse> = /*@__PURE__*/
  messageDesc(file_v1_image_image_service, 3);

/**
 * UploadImageRequest represents a request to upload an image
 *
 * @generated from message api.v1.image.UploadImageRequest
 */
export type UploadImageRequest = Message<"api.v1.image.UploadImageRequest"> & {
  /**
   * @generated from field: api.v1.image.EntityType entity_type = 1;
   */
  entityType: EntityType;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: string image_name = 3;
   */
  imageName: string;

  /**
   * @generated from field: bytes image_data = 4;
   */
  imageData: Uint8Array;
};

/**
 * Describes the message api.v1.image.UploadImageRequest.
 * Use `create(UploadImageRequestSchema)` to create a new message.
 */
export const UploadImageRequestSchema: GenMessage<UploadImageRequest> = /*@__PURE__*/
  messageDesc(file_v1_image_image_service, 4);

/**
 * UploadImageResponse represents a response containing an image
 *
 * @generated from message api.v1.image.UploadImageResponse
 */
export type UploadImageResponse = Message<"api.v1.image.UploadImageResponse"> & {
  /**
   * @generated from field: string presigned_url = 1;
   */
  presignedUrl: string;

  /**
   * @generated from field: string storage_path = 2;
   */
  storagePath: string;
};

/**
 * Describes the message api.v1.image.UploadImageResponse.
 * Use `create(UploadImageResponseSchema)` to create a new message.
 */
export const UploadImageResponseSchema: GenMessage<UploadImageResponse> = /*@__PURE__*/
  messageDesc(file_v1_image_image_service, 5);

/**
 * DeleteImageRequest represents a request to delete an image
 *
 * @generated from message api.v1.image.DeleteImageRequest
 */
export type DeleteImageRequest = Message<"api.v1.image.DeleteImageRequest"> & {
  /**
   * @generated from field: string storage_path = 1;
   */
  storagePath: string;
};

/**
 * Describes the message api.v1.image.DeleteImageRequest.
 * Use `create(DeleteImageRequestSchema)` to create a new message.
 */
export const DeleteImageRequestSchema: GenMessage<DeleteImageRequest> = /*@__PURE__*/
  messageDesc(file_v1_image_image_service, 6);

/**
 * CreateImageRequest represents a request to create an image
 *
 * @generated from message api.v1.image.CreateImageRequest
 */
export type CreateImageRequest = Message<"api.v1.image.CreateImageRequest"> & {
  /**
   * @generated from field: string original_url = 1;
   */
  originalUrl: string;

  /**
   * @generated from field: optional string content_hash = 2;
   */
  contentHash?: string;

  /**
   * @generated from field: optional int32 width = 3;
   */
  width?: number;

  /**
   * @generated from field: optional int32 height = 4;
   */
  height?: number;

  /**
   * @generated from field: optional int64 size_bytes = 5;
   */
  sizeBytes?: bigint;

  /**
   * @generated from field: optional string mime_type = 6;
   */
  mimeType?: string;

  /**
   * @generated from field: optional string alt_text = 7;
   */
  altText?: string;
};

/**
 * Describes the message api.v1.image.CreateImageRequest.
 * Use `create(CreateImageRequestSchema)` to create a new message.
 */
export const CreateImageRequestSchema: GenMessage<CreateImageRequest> = /*@__PURE__*/
  messageDesc(file_v1_image_image_service, 7);

/**
 * @generated from message api.v1.image.CreateImageResponse
 */
export type CreateImageResponse = Message<"api.v1.image.CreateImageResponse"> & {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId: string;
};

/**
 * Describes the message api.v1.image.CreateImageResponse.
 * Use `create(CreateImageResponseSchema)` to create a new message.
 */
export const CreateImageResponseSchema: GenMessage<CreateImageResponse> = /*@__PURE__*/
  messageDesc(file_v1_image_image_service, 8);

/**
 * GetImageRequest represents a request to get an image
 *
 * @generated from message api.v1.image.GetImageRequest
 */
export type GetImageRequest = Message<"api.v1.image.GetImageRequest"> & {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId: string;
};

/**
 * Describes the message api.v1.image.GetImageRequest.
 * Use `create(GetImageRequestSchema)` to create a new message.
 */
export const GetImageRequestSchema: GenMessage<GetImageRequest> = /*@__PURE__*/
  messageDesc(file_v1_image_image_service, 9);

/**
 * UpdateImageRequest represents a request to update an image
 *
 * @generated from message api.v1.image.UpdateImageRequest
 */
export type UpdateImageRequest = Message<"api.v1.image.UpdateImageRequest"> & {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId: string;

  /**
   * @generated from field: string alt_text = 2;
   */
  altText: string;
};

/**
 * Describes the message api.v1.image.UpdateImageRequest.
 * Use `create(UpdateImageRequestSchema)` to create a new message.
 */
export const UpdateImageRequestSchema: GenMessage<UpdateImageRequest> = /*@__PURE__*/
  messageDesc(file_v1_image_image_service, 10);

/**
 * ListImagesRequest represents a request to list images
 *
 * @generated from message api.v1.image.ListImagesRequest
 */
export type ListImagesRequest = Message<"api.v1.image.ListImagesRequest"> & {
  /**
   * @generated from field: optional string entity_type = 1;
   */
  entityType?: string;

  /**
   * @generated from field: optional int64 entity_id = 2;
   */
  entityId?: bigint;

  /**
   * @generated from field: optional string usage = 3;
   */
  usage?: string;

  /**
   * @generated from field: optional int32 page_size = 4;
   */
  pageSize?: number;

  /**
   * @generated from field: optional string page_token = 5;
   */
  pageToken?: string;
};

/**
 * Describes the message api.v1.image.ListImagesRequest.
 * Use `create(ListImagesRequestSchema)` to create a new message.
 */
export const ListImagesRequestSchema: GenMessage<ListImagesRequest> = /*@__PURE__*/
  messageDesc(file_v1_image_image_service, 11);

/**
 * ListImagesResponse represents a response containing a list of images
 *
 * @generated from message api.v1.image.ListImagesResponse
 */
export type ListImagesResponse = Message<"api.v1.image.ListImagesResponse"> & {
  /**
   * @generated from field: repeated api.v1.image.Image images = 1;
   */
  images: Image[];

  /**
   * @generated from field: optional string next_page_token = 2;
   */
  nextPageToken?: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message api.v1.image.ListImagesResponse.
 * Use `create(ListImagesResponseSchema)` to create a new message.
 */
export const ListImagesResponseSchema: GenMessage<ListImagesResponse> = /*@__PURE__*/
  messageDesc(file_v1_image_image_service, 12);

/**
 * AssociateImageRequest represents a request to associate an image with an entity
 *
 * @generated from message api.v1.image.AssociateImageRequest
 */
export type AssociateImageRequest = Message<"api.v1.image.AssociateImageRequest"> & {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;

  /**
   * @generated from field: int64 entity_id = 3;
   */
  entityId: bigint;

  /**
   * @generated from field: int32 position = 4;
   */
  position: number;

  /**
   * @generated from field: string usage = 5;
   */
  usage: string;
};

/**
 * Describes the message api.v1.image.AssociateImageRequest.
 * Use `create(AssociateImageRequestSchema)` to create a new message.
 */
export const AssociateImageRequestSchema: GenMessage<AssociateImageRequest> = /*@__PURE__*/
  messageDesc(file_v1_image_image_service, 13);

/**
 * DisassociateImageRequest represents a request to remove an image association
 *
 * @generated from message api.v1.image.DisassociateImageRequest
 */
export type DisassociateImageRequest = Message<"api.v1.image.DisassociateImageRequest"> & {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;

  /**
   * @generated from field: int64 entity_id = 3;
   */
  entityId: bigint;

  /**
   * @generated from field: string usage = 4;
   */
  usage: string;
};

/**
 * Describes the message api.v1.image.DisassociateImageRequest.
 * Use `create(DisassociateImageRequestSchema)` to create a new message.
 */
export const DisassociateImageRequestSchema: GenMessage<DisassociateImageRequest> = /*@__PURE__*/
  messageDesc(file_v1_image_image_service, 14);

/**
 * @generated from enum api.v1.image.EntityType
 */
export enum EntityType {
  /**
   * @generated from enum value: ENTITY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ENTITY_TYPE_ORG = 1;
   */
  ORG = 1,

  /**
   * @generated from enum value: ENTITY_TYPE_USER = 2;
   */
  USER = 2,

  /**
   * @generated from enum value: ENTITY_TYPE_LISTING = 3;
   */
  LISTING = 3,

  /**
   * @generated from enum value: ENTITY_TYPE_EVENT = 4;
   */
  EVENT = 4,

  /**
   * @generated from enum value: ENTITY_TYPE_REVIEW = 5;
   */
  REVIEW = 5,

  /**
   * @generated from enum value: ENTITY_TYPE_SERVICE = 6;
   */
  SERVICE = 6,

  /**
   * @generated from enum value: ENTITY_TYPE_PRODUCT = 7;
   */
  PRODUCT = 7,
}

/**
 * Describes the enum api.v1.image.EntityType.
 */
export const EntityTypeSchema: GenEnum<EntityType> = /*@__PURE__*/
  enumDesc(file_v1_image_image_service, 0);

/**
 * ImageService provides operations for managing images
 *
 * @generated from service api.v1.image.ImageService
 */
export const ImageService: GenService<{
  /**
   * GetPresignedUploadUrl is a multipart/form-data endpoint for uploading images
   *
   * @generated from rpc api.v1.image.ImageService.GetPresignedUploadUrl
   */
  getPresignedUploadUrl: {
    methodKind: "unary";
    input: typeof GetPresignedUploadUrlRequestSchema;
    output: typeof GetPresignedUploadUrlResponseSchema;
  },
  /**
   * UploadImage uploads an image to the server
   *
   * @generated from rpc api.v1.image.ImageService.UploadImage
   */
  uploadImage: {
    methodKind: "unary";
    input: typeof UploadImageRequestSchema;
    output: typeof UploadImageResponseSchema;
  },
  /**
   * DeleteImage deletes an image from the server
   *
   * @generated from rpc api.v1.image.ImageService.DeleteImage
   */
  deleteImage: {
    methodKind: "unary";
    input: typeof DeleteImageRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_image_image_service, 0);

